export default "__VITE_ASSET__SVeKL2qE__"